import { __awaiter, __generator } from "tslib";
import { fetchFamilyPrice } from '@gn-audio/core/api/pricing/fetch-family-price';
import { fetchGroupPrice } from '@gn-audio/core/api/pricing/fetch-group-price';
import { fetchProductPrice } from '@gn-audio/core/api/pricing/fetch-product-price';
import { fetchEcomSetting } from '@gn-audio/core/api/site-settings/fetch-ecom-setting';
/**
 * Fetches price of the entity of certain type and ID
 * @param productId Entity ID
 * @param productType Entity type i.e. family, group
 * @returns Promise with the price of the entity
 * @remarks Returns null instead of throwing error
 * @async
 */
export var fetchPrice = function (productId, productType, queryParameters) { return __awaiter(void 0, void 0, void 0, function () {
    var ecomSetting, pricePromise;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchEcomSetting()];
            case 1:
                ecomSetting = _a.sent();
                if (!(ecomSetting === null || ecomSetting === void 0 ? void 0 : ecomSetting.ecomEnabled)) {
                    return [2 /*return*/, null];
                }
                switch (productType) {
                    case "g" /* Group */:
                        pricePromise = fetchGroupPrice(productId);
                        break;
                    case "p" /* Product */:
                        pricePromise = fetchProductPrice(productId, queryParameters);
                        break;
                    case "f" /* Family */:
                    default:
                        pricePromise = fetchFamilyPrice(productId);
                        break;
                }
                return [4 /*yield*/, pricePromise];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
